import React from 'react'
import { FormattedMessage } from 'react-intl'

import styled, { useTheme } from 'styled-components/native'

import { BodyText } from '@lyrahealth-inc/ui-core-crossplatform/src/atoms/bodyText/BodyText'
import { SecondaryButton } from '@lyrahealth-inc/ui-core-crossplatform/src/atoms/secondaryButton/SecondaryButton'
import { Title } from '@lyrahealth-inc/ui-core-crossplatform/src/atoms/title/Title'
import { BodyTextSize, TitleSize } from '@lyrahealth-inc/ui-core-crossplatform/src/styles/typeStyles'
import { ThemeType } from '@lyrahealth-inc/ui-core-crossplatform/src/utils/themes/ThemeProvider'
import { tID } from '@lyrahealth-inc/ui-core-crossplatform/src/utils/utils'

import MessengerUtilityItemHeader from '../utilityItem/MessengerUtilityItemHeader'

type ProviderTemplateHeaderProps = {
  onAddTemplatePress: () => void
  showBottomBorder?: boolean
}

const Container = styled.View<{ theme: ThemeType }>(({ theme }) => ({
  flexDirection: 'column',
  backgroundColor: theme.colors.backgroundPrimary,
  zIndex: 'unset',
}))

const HeaderRow = styled(MessengerUtilityItemHeader)<{ showDivider: boolean; theme: ThemeType }>(
  ({ showDivider, theme }) => ({
    borderBottomWidth: '1px',
    borderBottomColor: showDivider ? `${theme.colors.borderDefault}` : 'none',
    borderBottomStyle: 'solid',
    justifyContent: 'space-between',
  }),
)

const LeftSection = styled.View({
  flexDirection: 'column',
  justifyContent: 'center',
})

const RightSection = styled.View({
  flexDirection: 'row',
  alignItems: 'center',
})

export const ProviderTemplateHeader: React.FC<ProviderTemplateHeaderProps> = ({
  onAddTemplatePress,
  showBottomBorder = true,
}) => {
  const theme = useTheme()

  return (
    <Container testID={tID('ProviderTemplateHeader')}>
      <HeaderRow showDivider={showBottomBorder}>
        <LeftSection>
          <Title
            size={TitleSize.MEDIUM}
            text={<FormattedMessage defaultMessage='Templates' description='Header for template page' />}
          />
          <BodyText
            size={BodyTextSize.SMALL}
            text={
              <FormattedMessage
                defaultMessage='Set up message shortcuts'
                description='Subheader for template page explaining the purpose'
              />
            }
            color={theme.colors.textSecondary}
          />
        </LeftSection>
        <RightSection>
          <SecondaryButton
            testID={tID('ProviderTemplateHeader-add-template-button')}
            text={<FormattedMessage defaultMessage='Add template' description='Button to add a new template' />}
            onPress={onAddTemplatePress}
          />
        </RightSection>
      </HeaderRow>
    </Container>
  )
}
